import React, {
  useContext,
  useMemo,
} from 'react';
import { HeadingBanner } from 'anf-core-react';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import Tmnt from '../../Tmnt/Tmnt';
import BillingAddressForm from './BillingAddressForm/BillingAddressForm';

export default function BillingAddressContainer() {
  const {
    checkoutPageState,
  } = useContext(CheckoutPageContext);

  const { textFor, bagItems } = checkoutPageState;

  const hasOnlyEGiftCard = useMemo(() => bagItems?.hasOnlyEGiftCard, [bagItems]);

  if (hasOnlyEGiftCard) {
    return (
      <div className="billing-address-form">
        <input type="hidden" name="billingAddressSameAsShipping" data-testId="billingAddressSameAsShipping" value={false} />
        <input type="hidden" name="shippingAddressSameAsBilling" data-testId="shippingAddressSameAsBilling" value />
      </div>
    );
  }

  return (
    <div className="billing-address-container">
      {textFor?.billingAddress && (
        <HeadingBanner variant="boxed">
          <h2>
            <Tmnt tmnt={textFor?.billingAddress} />
          </h2>
        </HeadingBanner>
      )}
      <BillingAddressForm />
    </div>
  );
}
